import { Nullable } from '@tcc/common';

export enum AgVizPopulationLayers {
  ActualByMass = 'ACTUAL_POPULATION_BY_MASS',
  TargetByMass = 'TARGET_POPULATION_BY_MASS',
  ActualBySeedCount = 'ACTUAL_POPULATION_BY_SEED_COUNT',
  TargetBySeedCount = 'TARGET_POPULATION_BY_SEED_COUNT',
}

export interface Color {
  alpha: Nullable<number>;
  blue: number;
  green: number;
  red: number;
}

export enum LegendItemType {
  Categorical = 'CategoricalGeospatialAssetLegendItem',
  Continuous = 'ContinuousGeospatialAssetLegendItem',
}

export interface BaseAssetLegendItem {
  __typename: LegendItemType;
  color: Color;
}
export interface CategoricalGeospatialAssetLegendItem extends BaseAssetLegendItem {
  __typename: LegendItemType.Categorical;
  label: string;
}

export interface ContinuousGeospatialAssetLegendItem extends BaseAssetLegendItem {
  __typename: LegendItemType.Continuous;
  min: Nullable<number>;
  max: Nullable<number>;
}

export interface CategoricalAssetLegend {
  items: CategoricalGeospatialAssetLegendItem[];
  units: Nullable<string>;
}

export interface ContinuousAssetLegend {
  items: ContinuousGeospatialAssetLegendItem[];
  units: Nullable<string>;
}

export interface MixedAssetLegend {
  items: Array<ContinuousGeospatialAssetLegendItem | CategoricalGeospatialAssetLegendItem>;
  units: Nullable<string>;
}

export type Legend = CategoricalAssetLegend | ContinuousAssetLegend | MixedAssetLegend;

export interface RasterTileset {
  thumbnailUrl: Nullable<string>;
  version: Nullable<string>;
  tileUrlTemplate: string;
  source: string;
  legend: Legend;
}

export interface MachineDataMap {
  name: string;
  assets: RasterTileset[];
}

export interface MachineDataMapsResponse {
  data: {
    // Nullable from commons
    field: Nullable<{
      name: string;
      machineDataMaps: Nullable<{
        maps: MachineDataMap[];
      }>;
    }>;
  };
}
